<template>
  <div class="input-images-wrapp">
    <div class="input-images-grid grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-10">
      <input
        id="inputImage"
        type="file"
        multiple
        @change="handleChange"
        :size="maxSize"
        class="absolute opacity-0 -z-10 pointer-events-none peer"
      />

      <!-- labels -->
      <label
        v-for="n in 4"
        v-if="images.length < n"
        :key="n"
        for="inputImage"
        class="relative flex flex-col items-center justify-center gap-3 px-4 py-3 aspect-[1.4/1] border border-gray/20 hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] hover:rounded-md duration-300"
        :class="n == 4 ? 'lg:hidden' : ''"
      >
        <svg class="w-6 h-6">
          <use xlink:href="#img" />
        </svg>

        <p class="text-xs sm:text-sm whitespace-nowrap">Upload Image</p>
      </label>
      <!-- /labels -->

      <!-- Images -->
      <div
        v-for="(image, key) in images"
        :key="key"
        class="relative flex border border-gray/20 px-4 py-3 aspect-[1.4/1] -order-1"
      >
        <button
          type="button"
          class="absolute top-1.5 right-1.5 flex items-center justify-center w-9 h-9 bg-white text-blue outline-none hover:scale-90 group duration-200 z-10"
          @click="deleteImage(key)"
          aria-label="Delete image"
        >
          <svg class="w-4 h-4 group-hover:scale-110 group-hover:rotate-90 duration-200">
            <use xlink:href="#close" />
          </svg>
        </button>

        <div class="relative w-full h-full">
          <img class="w-full h-full object-cover" :src="image" alt />
        </div>
      </div>
      <!-- /Images -->

      <label
        v-if="images.length < maxLength"
        for="inputImage"
        class="col-start-1 col-end-3 lg:col-end-4 flex items-center justify-center h-20 border border-gray/20 peer-checked:border-white peer-focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] peer-focus-visible:rounded-md hover:rounded-md duration-300"
      >
        <p>Upload more images</p>
      </label>

      <div
        v-if="errorShow"
        class="col-start-1 col-end-3 lg:col-end-4 flex items-center min-h-[80px] border border-red duration-300"
      >
        <div
          class="flex flex-col sm:flex-row items-center justify-between text-center sm:text-left gap-6 sm:gap-10 py-6 sm:py-0 px-8 w-full"
        >
          {{ errorMessage }}
          <button
            @click="errorShow = false"
            class="border border-gray/20 py-2 px-8 hover:rounded-md focus-visible:rounded-md hover:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] focus-visible:shadow-[0_0px_0px_5px_rgba(255,255,255,0.2)] duration-300 outline-none"
            type="button"
          >Okay</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inputImage',

  data() {
    return {
      images: [],
      errorMessage: '',
      errorShow: false,
    }
  },
  props: {
    maxLength: {
      type: Number,
      default: 8,
    },
    maxSize: {
      type: Number,
      default: 4000000,
    },
  },

  methods: {
    handleChange(e) {
      const files = [...this.images, ...e.target?.files]

      this.images = files
        // Map images
        .map((img, index) => {
          if (img.size > 4000000) {
            this.showError()
          } else if (index <= this.maxLength) {
            return typeof img === 'string' ? img : URL.createObjectURL(img)
          }
        })
        // Remove undefined in array (if images size > 4mb)
        .filter(function(img) {
          return typeof img !== 'undefined'
        })

      window.smoother.scrollTrigger.refresh()

      if (e.target?.files) {
        this.$emit('input', files)
      }
    },

    deleteImage(key) {
      this.images.splice(key, 1)
      window.smoother.scrollTrigger.refresh()

      this.$emit('input', this.images)
    },

    showError() {
      this.errorMessage = `Some images are too large.
            Please choose an image up to ${this.maxSize / 1000000}MB`
      this.errorShow = true

      this.hideErrorTimer()
    },

    hideErrorTimer() {
      setTimeout(() => {
        // this.errorShow = false
      }, 5000)
    },
  },
}
</script>
